var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
// import { lazy } from "react";
import * as Logos from "./Logos";
import "./Logotype.css";
/**
 * Displays a logo or icon for a product, or TimeEdit itself.
 * All Logotypes can be extended using className or styles, allowing to
 * set custom dimensions and backgrounds.
 *
 * For TimeEdit, use the "TE" or "TEWithText" logos.
 */
export default function Logotype(_a) {
    var { id, size, className = "", alt } = _a, props = __rest(_a, ["id", "size", "className", "alt"]);
    if (!id) {
        throw new Error(`Property "id" is required`);
    }
    // const [LazyLogotypeComponent, setLazyLogotypeComponent] =
    //   useState<LazyExoticComponent<ComponentType>>();
    // Fetch Lazy Logo
    // useEffect(() => {
    //   try {
    //     const LazyLogotype = lazy(
    //       () =>
    //         import(
    //           `./Logos/${id}${
    //             process.env.NODE_ENV === "development" ? ".tsx" : ".js"
    //           }`
    //         )
    //     );
    //     setLazyLogotypeComponent(LazyLogotype);
    //   } catch {
    //     throw new Error(`Unable to load logotype ${id}, are you sure its valid?`);
    //   }
    // }, [id]);
    const Logo = Logos[id];
    return (_jsx("div", Object.assign({ className: `
        te-logotype
        te-inline-block te-w-auto te-box-content te-min-h-icon-sm
        ${size === 24 ? "te-h-icon-sm" : ""}
        ${size === 32 ? "te-h-icon-md" : ""}
        ${size === 48 ? "te-h-icon-lg" : ""}
        ${size === 72 ? "te-h-icon-xl" : ""}
        ${className}
      `, role: "img", "aria-label": alt }, props, { children: _jsx("div", { "aria-hidden": "true", className: "te-h-full", children: _jsx(Logo, {}) }) })));
}
